/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Resume_Perf_Col_ResumeInputs */

const en_analytics_resume_perf_col_resume = /** @type {(inputs: Analytics_Resume_Perf_Col_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume`)
};

const de_analytics_resume_perf_col_resume = /** @type {(inputs: Analytics_Resume_Perf_Col_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebenslauf`)
};

const fr_analytics_resume_perf_col_resume = /** @type {(inputs: Analytics_Resume_Perf_Col_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV`)
};

const es_analytics_resume_perf_col_resume = /** @type {(inputs: Analytics_Resume_Perf_Col_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Currículum`)
};

const it_analytics_resume_perf_col_resume = /** @type {(inputs: Analytics_Resume_Perf_Col_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Curriculum Vitae`)
};

const nl_analytics_resume_perf_col_resume = /** @type {(inputs: Analytics_Resume_Perf_Col_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV`)
};

const pl_analytics_resume_perf_col_resume = /** @type {(inputs: Analytics_Resume_Perf_Col_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV`)
};

const fi_analytics_resume_perf_col_resume = /** @type {(inputs: Analytics_Resume_Perf_Col_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansioluettelo`)
};

const da_analytics_resume_perf_col_resume = /** @type {(inputs: Analytics_Resume_Perf_Col_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV`)
};

const sv_analytics_resume_perf_col_resume = /** @type {(inputs: Analytics_Resume_Perf_Col_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV`)
};

/**
* | output |
* | --- |
* | "Resume" |
*
* @param {Analytics_Resume_Perf_Col_ResumeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const analytics_resume_perf_col_resume = /** @type {((inputs?: Analytics_Resume_Perf_Col_ResumeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Resume_Perf_Col_ResumeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_analytics_resume_perf_col_resume(inputs)
	if (locale === "fr") return fr_analytics_resume_perf_col_resume(inputs)
	if (locale === "es") return es_analytics_resume_perf_col_resume(inputs)
	if (locale === "it") return it_analytics_resume_perf_col_resume(inputs)
	if (locale === "nl") return nl_analytics_resume_perf_col_resume(inputs)
	if (locale === "pl") return pl_analytics_resume_perf_col_resume(inputs)
	if (locale === "fi") return fi_analytics_resume_perf_col_resume(inputs)
	if (locale === "da") return da_analytics_resume_perf_col_resume(inputs)
	if (locale === "sv") return sv_analytics_resume_perf_col_resume(inputs)
	return en_analytics_resume_perf_col_resume(inputs)
});